import { defineComponent, computed } from "vue";
import SvgIcon from "./SvgIcon.vue.mjs";
import ArrowUpIcon from "../icons/ArrowUpIcon.vue.mjs";
import { IconButtonLayout } from "../../../constants/room.mjs";
import { isMobile } from "../../../utils/environment.mjs";
import UnSupportIcon from "../icons/UnSupportIcon.vue.mjs";
import "../../../directives/vTap.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "IconButton",
  props: {
    title: { default: "" },
    hasMore: { type: Boolean, default: false },
    hideHoverEffect: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    layout: { default: IconButtonLayout.VERTICAl },
    icon: { default: null },
    isNotSupport: { type: Boolean, default: false },
    theme: { default: void 0 }
  },
  emits: ["click-icon", "click-more"],
  setup(__props, { emit }) {
    const props = __props;
    const themeClass = computed(
      () => props.theme ? `tui-theme-${props.theme}` : ""
    );
    const iconContentClass = computed(() => {
      if (props.layout === IconButtonLayout.HORIZONTAL) {
        return "icon-content-horizontal";
      }
      return "icon-content-vertical";
    });
    const handleClickEvent = () => {
      emit("click-icon");
    };
    return { __sfc: true, props, emit, themeClass, iconContentClass, handleClickEvent, SvgIcon, ArrowUp: ArrowUpIcon, isMobile, UnSupportIcon };
  }
});
export {
  _sfc_main as default
};
